// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3-Jda","description":"PatientConsentPreview_description__6tSD1"};